import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

class Ubytovani extends React.Component {
    render() {
        if(this.state.loading) return null;
        /*if(!this.state.ubytovani.length) 
            return (
                <div className="ubytovani" style={{paddingLeft: 20}}>Škola nezajišťuje ubytování</div>
            );*/

        if(this.state.zvoleneUbytovaniKey !== null) {
            let date = new Date(this.state.ubytovani[this.state.zvoleneUbytovaniKey].nastupy[0]);
            var nastupText = date.getDate() +"."+ (date.getMonth()+1) + "." + date.getFullYear();
            var pocetStudentu = this.state.ubytovani[this.state.zvoleneUbytovaniKey].pocetStudentu;
        }
        
        return (
            <div className="ubytovani2">
                <div className="formRow">
                    <label>Ubytování:</label> 
                    <div className="formRow-right">
                        <select name={`prihlaska[ubytovani][id]`} value={this.state.zvoleneUbytovani} onChange={this._changeUbytovani} required>
                            <option value="">-- Zvolte ubytování --</option>
                            {this.state.ubytovani.map((ubytovani, key) => {
                                let luzek = ubytovani.pocetLuzek ? "Lůžek: "+ubytovani.pocetLuzek : "";
                                let strava = luzek && ubytovani.strava ? ", "+ubytovani.strava : "";
                                let desc = luzek || strava ? "("+luzek+strava+")" :"";
                                return <option key={key} value={ubytovani.idUbytovani} data-key={key}>{ubytovani.nazev} {desc}</option> 
                            })}
                            <option value="Nemám zájem o ubytování">Nemám zájem o ubytování</option>
                        </select>
                    </div>
                </div>
                {this.state.zvoleneUbytovaniKey !== null && 
                    <div className="formRow">
                        <label>Délka ubytování:</label> 
                        <div className="formRow-right">
                            <select name={`prihlaska[ubytovani][delka]`} value={this.state.zvolenaDelkaUbytovani} onChange={this._changeDelka} required>
                                <option value="">-- Zvolte délku ubytování --</option>
                                {this.state.ubytovani[this.state.zvoleneUbytovaniKey].delkaUbytovani.map((delka, key) => {
                                    let weeks = delka/7;
                                    return <option key={key} value={delka}>
                                            {weeks}
                                            {weeks === 1 && " týden"}
                                            {(weeks > 1 && weeks < 5) && " týdny"}
                                            {weeks >= 5 && " týdnů"}
                                        </option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                {this.state.zvoleneUbytovaniKey !== null && 
                    <div>
                        <div className="formRow">
                            <label>Nástup na ubytování:</label> 
                            <div className="formRow-right">
                                {nastupText}
                                <input type="hidden" name="prihlaska[ubytovani][nastup]" value={this.state.ubytovani[this.state.zvoleneUbytovaniKey].nastupy[0]} />
                            </div>
                        </div>

                       {pocetStudentu > 1 && 
                            <div className="formRow">
                                <label>S kým jedu:</label> 
                                <div className="formRow-right">
                                    <input className="text" maxlength="128" name="prihlaska[ubytovani][spolubydlici]" required="" size="55" type="text" />
                                    Toto je pro 
                                    {pocetStudentu < 5 && `${pocetStudentu} studenty`} 
                                    {pocetStudentu >= 5 && `${pocetStudentu} studentů`}
                                </div>
                            </div>
                        }


                        <div className="formRow">
                            <label>Trpíte alergiemi:</label> 
                            <div className="checkbox">
                                <input type="radio" name={`prihlaska[ubytovani][alergie]`} 
                                    id={`prihlaska-alergie-Yes`} value="Yes" 
                                    checked={this.state.alergie === "Yes"} 
                                    onChange={(e) => {this.setState({alergie: "Yes"})}}

                                    />

                                <label htmlFor={`prihlaska-alergie-Yes`}>Ano</label>


                                <input type="radio" name={`prihlaska[ubytovani][alergie]`} 
                                    id={`prihlaska-alergie-No`} value="No" 
                                    checked={this.state.alergie !== "Yes"}
                                    onChange={(e) => {this.setState({alergie: "No"})}}
                                    />

                                <label htmlFor={`prihlaska-alergie-No`}>Ne</label>
                            </div>
                        </div>

                        <div className="formRow">
                            <label>Kouříte:</label> 
                            <div className="checkbox">
                                <input type="radio" name={`prihlaska[ubytovani][koureni]`} 
                                    id={`prihlaska-koureni-Yes`} value="Yes" 
                                    checked={this.state.koureni === "Yes"} 
                                    onChange={(e) => {this.setState({koureni: "Yes"})}}

                                    />

                                <label htmlFor={`prihlaska-koureni-Yes`}>Ano</label>


                                <input type="radio" name={`prihlaska[ubytovani][koureni]`} 
                                    id={`prihlaska-koureni-No`} value="No" 
                                    checked={this.state.koureni !== "Yes"}
                                    onChange={(e) => {this.setState({koureni: "No"})}}
                                    />

                                <label htmlFor={`prihlaska-koureni-No`}>Ne</label>
                            </div>
                        </div>

                        <div className="formRow">
                            <label>Držíte speciální dietu:</label> 
                            <div className="checkbox">
                                <input type="radio" name={`prihlaska[ubytovani][dieta]`} 
                                    id={`prihlaska-dieta-Yes`} value="Yes" 
                                    checked={this.state.dieta === "Yes"} 
                                    onChange={(e) => {this.setState({dieta: "Yes"})}}

                                    />

                                <label htmlFor={`prihlaska-dieta-Yes`}>Ano</label>


                                <input type="radio" name={`prihlaska[ubytovani][dieta]`} 
                                    id={`prihlaska-dieta-No`} value="No" 
                                    checked={this.state.dieta !== "Yes"}
                                    onChange={(e) => {this.setState({dieta: "No"})}}
                                    />

                                <label htmlFor={`prihlaska-dieta-No`}>Ne</label>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    constructor(props) {
        super(props);
        let loadedData = props.store.loadedData;
        console.log(loadedData);
        this.state = {
            idMesta: null,
            idSkoly: null,
            kurzNastup: null,
            ubytovani: [],
            zvoleneUbytovani: loadedData["prihlaska[ubytovani][id]"] ? loadedData["prihlaska[ubytovani][id]"] : "",
            zvolenaDelkaUbytovani: loadedData["prihlaska[ubytovani][delka]"] ? loadedData["prihlaska[ubytovani][delka]"] : "",
            koureni: loadedData["prihlaska[ubytovani][koureni]"] ? loadedData["prihlaska[ubytovani][koureni]"] : "No",
            alergie: loadedData["prihlaska[ubytovani][alergie]"] ? loadedData["prihlaska[ubytovani][alergie]"] : "No",
            dieta: loadedData["prihlaska[ubytovani][dieta]"] ? loadedData["prihlaska[ubytovani][dieta]"] : "No",
            zvoleneUbytovaniKey: null,
            zvolenyNastup: "",
            loading: true
        }
    }

    componentDidMount() {
        this._loadUbytovani(this.props.idSkoly, this.props.idMesta, this.props.kurzNastup, this.props.kurzDelka, true);
    }

    componentWillReceiveProps(newProps) {
        this._loadUbytovani(newProps.idSkoly, newProps.idMesta, newProps.kurzNastup, newProps.kurzDelka, false);
    }

    _loadUbytovani = (idSkoly, idMesta, kurzNastup, kurzDelka, onMount) => {
        const nastupDate = new Date(kurzNastup);
        if(nastupDate.getFullYear() < 2018) return;
        if(kurzNastup !== this.state.kurzNastup || kurzDelka !== this.state.kurzNastup) {
            this.setState({
                idMesta: idMesta,
                idSkoly: idSkoly,
                kurzNastup: kurzNastup,
                kurzDelka: kurzDelka,
                zvolenaDelkaUbytovani: onMount ? this.state.zvolenaDelkaUbytovani : "",
            });
        } else if(idMesta === this.state.idMesta && idSkoly === this.state.idSkoly) {
            return;
        } else {
            this.setState({
                idMesta: idMesta,
                idSkoly: idSkoly,
                kurzNastup: kurzNastup,
                kurzDelka: kurzDelka,
                ubytovani: [],
                zvoleneUbytovani: "",
                zvolenaDelkaUbytovani: "",
                zvoleneUbytovaniKey: null,
                zvolenyNastup: "",
                loading: true
            });
        }
        

        axios.get(this.props.store.apiUrl, {params: {
            seznam: "ubytovani",
            idMesta: idMesta,
            idSkoly: idSkoly,
            kurzNastup: kurzNastup,
            maxDelka: kurzDelka
        }})
            .then((response) => {
                let zvoleneUbytovaniKey = null;
                if(this.state.zvoleneUbytovani) {
                    for(let key in response.data) {
                        if(response.data[key].idUbytovani === this.state.zvoleneUbytovani) {
                            zvoleneUbytovaniKey = key;
                        }
                    }
                }
                this.setState({
                    ubytovani: response.data,
                    loading: false,
                    zvoleneUbytovaniKey: zvoleneUbytovaniKey
                });
            })
            .catch((error) => {
                Sentry.captureException(error);
                alert("Došlo k neočekáváné chybě(#A7) při načítání ubytování. Prosím kontaktujte nás přímo.")
            });
    }

    _changeUbytovani = (e) => {
        let value = e.target.value;
        let key = e.target.selectedIndex-1;
        if(key < 0 || value === "Nemám zájem o ubytování") key = null;
        this.setState({
            zvoleneUbytovani: value,
            zvoleneUbytovaniKey: key,
        });
    }

    _changeDelka = (e) => {
        let value = e.target.value;
        this.setState({
            zvolenaDelkaUbytovani: value,
        });
    }

    _changeNastup = (e) => {
        let value = e.target.value;
        this.setState({
            zvolenyNastup: value,
        });
    }
}

export default Ubytovani;


// WEBPACK FOOTER //
// ./resources/prihlaska/ubytovani.js